import { useOutletContext } from "react-router-dom"
import { GenericViewerContext } from "../GenericViewer"

export const useGenericViewerContext = () => {
    const context = useOutletContext<GenericViewerContext>()

    return context || { isInsideViewer: false }
}
